import Modal from "../shared/modal";
import PropTypes from "prop-types";

const propTypes = {
  isModalOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
};

const ConciergeModal = ({ isModalOpen, handleCloseModal = () => {} }) => {
  const attentiveUrl = "https://renttherunway.attn.tv/p/TrG/landing-page";
  const additionalStyles = {
    content: {
      padding: "0",
    },
  };

  const renderCloseIcon = () => {
    return (
      <svg viewBox="0 0 44 44">
        <line x1="10" y1="34" x2="34" y2="10" />
        <line x1="10" y1="10" x2="34" y2="34" />
      </svg>
    );
  };

  const renderCloseButton = () => {
    return (
      <button className={"close-button"} aria-label={"Close"} onClick={handleCloseModal}>
        {renderCloseIcon()}
      </button>
    );
  };

  return (
    <Modal isOpen={isModalOpen} isFullScreen={true} ariaHideApp={false} additionalStyles={additionalStyles}>
      <div className="concierge-notification-modal" data-test-id={"concierge-modal"}>
        <iframe src={attentiveUrl} title="attentive-iframe" id="attentive-iframe" className="landing-page-iframe" />
        {renderCloseButton()}
      </div>
    </Modal>
  );
};

ConciergeModal.propTypes = propTypes;
export default ConciergeModal;
